<template>
  <v-container fluid class="pa-0">
    <v-layout row wrap justify-space-around>
      <v-flex xl12 lg12 md12 sm12 xs12>
        <v-card class="pa-5 back-card">
          <v-layout row wrap justify-space-around>
            <v-flex xl4 lg4 md4 sm12 xs12>
              <div class="title-newsletter">عضویت در خبرنامه</div>با عضوی در خبرنامه از آخرین خبرهای ما با خبر شوید.
            </v-flex>
            <v-flex xl8 lg8 md8 sm12 xs12>
              <v-layout row wrap justify-space-around>
                <v-flex xl8 lg8 md8 sm12 xs12>
                  <v-text-field
                    label="Solo"
                    single-line
                    type="email"
                    placeholder="ایمیل خود را وارد کنید"
                    v-model="email"
                    :rules="emailRules"
                    solo
                    round
                    height="55"
                  ></v-text-field>
                </v-flex>
                <v-flex xl4 lg4 md4 sm12 xs12>
                  <div class="text-xs-center">
                    <v-btn round large color="green accent-4" @click="subscribe(email)" dark>
                      عضویت
                      <v-icon left dark>done</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar :color="color" v-model="snackbar">{{msg}}</v-snackbar>
    <v-dialog v-model="loading" persistent fullscreen content-class="loading-dialog">
      <v-container fill-height>
        <v-layout row justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" color="purple"></v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import SubscribeService from "@/services/SubscribeService";
export default {
  data() {
    return {
      email: null,
      res: null,
      msg: null,
      color: null,
      snackbar: false,
      loading: false,
      emailRules: []
    };
  },
  methods: {
    async subscribe(email) {
      try {
        if (!this.emailRules.length) {
          return;
        }
        this.loading = true;
        this.res = await SubscribeService.subscribe(email);
        this.loading = false;
        console.log(this.res.request.response);
        if (this.res.request.response == 1) {
          this.msg = "موفق!";
          this.snackbar = true;
          this.color = "success";
        } else if (this.res.request.response == 0) {
          this.msg = "ناموفق!بعدا تلاش کنید";
          this.snackbar = true;
          this.color = "error";
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    email: function(mail) {
      // e_Mail is the exact name used in v-model
      if (mail !== "") {
        this.emailRules = [
          v =>
            v.match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ) || "ایمیل نامعتبر"
        ];
      } else if (mail === "") {
        this.emailRules = [];
      }
    }
  }
};
</script>

<style scoped>
.back-card {
  background: url("../../assets/u6.png") no-repeat;
  background-size: cover;
}
.title-newsletter {
  font-size: 24px;
  margin-bottom: 10px;
  color: #e91e63;
}
</style>
